export const mockDashboard = {
  summary: {
    activeOrders: 36,
    checkRequired: 7,
    changeReview: 3,
    deliveryRisk: 4,
    planPending: 9,
  },
  riskDistribution: {
    NORMAL: 21,
    ATTENTION: 8,
    HIGH: 5,
    OVERDUE: 2,
  },
  actionItems: [
    {
      order_line_id: 9001,
      order_no: "ORD-2026-0901-001",
      customer_name: "한빛정밀",
      item_name_snapshot: "정밀 이송 베이스 플레이트",
      requested_due_date: "2028-03-31",
      risk_level: "HIGH",
      action_type: "HIGH_RISK",
    },
    {
      order_line_id: 9002,
      order_no: "ORD-2026-0904-005",
      customer_name: "태림기계",
      item_name_snapshot: "대형 스핀들 하우징",
      requested_due_date: "2027-12-20",
      risk_level: "OVERDUE",
      action_type: "OVERDUE",
    },
    {
      order_line_id: 9003,
      order_no: "ORD-2026-0901-002",
      customer_name: "세화모빌리티",
      item_name_snapshot: "자동화 라인 고정 레일 세트",
      requested_due_date: "2028-02-28",
      risk_level: "ATTENTION",
      action_type: "CHANGE_REVIEW",
    },
    {
      order_line_id: 9004,
      order_no: "ORD-2026-0902-003",
      customer_name: "대진산업",
      item_name_snapshot: "컨베이어 메인 프레임",
      requested_due_date: "2027-11-15",
      risk_level: "ATTENTION",
      action_type: "PLAN_REVIEW",
    },
  ],
  weeklyDue: [
    { week: 1, label: "이번 주", count: 3 },
    { week: 2, label: "2주 후", count: 5 },
    { week: 3, label: "3주 후", count: 4 },
    { week: 4, label: "4주 후", count: 7 },
    { week: 5, label: "5주 후", count: 6 },
    { week: 6, label: "6주 후", count: 2 },
  ],
};

export const mockOrders = [
  {
    order_id: 9101,
    order_line_id: 9101,
    order_no: "ORD-2026-0901-001",
    customer_po_no: "HB-PO-2026-09-001",
    line_no: 1,
    customer_name: "한빛정밀",
    site_name: "울산 2공장",
    item_code_snapshot: "LONG-LEAD-001",
    item_name_snapshot: "대형 스핀들 하우징",
    specification_snapshot: "장기 조달품 포함",
    order_quantity: 12,
    unit_code: "EA",
    requested_due_date: "2028-06-30",
    required_start_date: "2026-12-04",
    check_required_date: "2026-10-02",
    schedule_status: "CHECK_REQUIRED",
    risk_level: "ATTENTION",
    available_margin_days: 68,
  },
  {
    order_id: 9101,
    order_line_id: 9102,
    order_no: "ORD-2026-0901-001",
    customer_po_no: "HB-PO-2026-09-001",
    line_no: 2,
    customer_name: "한빛정밀",
    site_name: "울산 2공장",
    item_code_snapshot: "BASE-PLATE-390",
    item_name_snapshot: "정밀 이송 베이스 플레이트",
    specification_snapshot: "서브축 가공품 / 고객 승인 필요",
    order_quantity: 8,
    unit_code: "EA",
    requested_due_date: "2028-03-31",
    required_start_date: "2026-09-01",
    check_required_date: "2026-08-20",
    schedule_status: "CHECK_REQUIRED",
    risk_level: "HIGH",
    available_margin_days: 0,
  },
  {
    order_id: 9102,
    order_line_id: 9103,
    order_no: "ORD-2026-0901-002",
    customer_po_no: "SH-PO-2026-09-014",
    line_no: 1,
    customer_name: "세화모빌리티",
    site_name: "아산 장비센터",
    item_code_snapshot: "RAIL-SET-A18",
    item_name_snapshot: "자동화 라인 고정 레일 세트",
    specification_snapshot: "설치 간섭 검토 필요",
    order_quantity: 4,
    unit_code: "SET",
    requested_due_date: "2028-02-28",
    required_start_date: "2026-10-16",
    check_required_date: "2026-09-04",
    schedule_status: "CHANGE_REVIEW",
    risk_level: "ATTENTION",
    available_margin_days: 33,
  },
  {
    order_id: 9103,
    order_line_id: 9104,
    order_no: "ORD-2026-0902-003",
    customer_po_no: "DJ-PO-2026-09-021",
    line_no: 1,
    customer_name: "대진산업",
    site_name: "광주 생산센터",
    item_code_snapshot: "FRAME-CV-220",
    item_name_snapshot: "컨베이어 메인 프레임",
    specification_snapshot: "용접 후 정밀가공",
    order_quantity: 16,
    unit_code: "EA",
    requested_due_date: "2027-11-15",
    required_start_date: "2026-09-18",
    check_required_date: "2026-09-01",
    schedule_status: "PLAN_REVIEW",
    risk_level: "ATTENTION",
    available_margin_days: 17,
  },
  {
    order_id: 9104,
    order_line_id: 9105,
    order_no: "ORD-2026-0903-004",
    customer_po_no: "WJ-PO-2026-09-006",
    line_no: 1,
    customer_name: "우진테크",
    site_name: "대구 생산센터",
    item_code_snapshot: "SHAFT-28A",
    item_name_snapshot: "구동 샤프트 정밀 연마품",
    specification_snapshot: "SUS304 / Ra 0.8",
    order_quantity: 40,
    unit_code: "EA",
    requested_due_date: "2027-08-31",
    required_start_date: "2026-12-30",
    check_required_date: "2026-11-18",
    schedule_status: "CONFIRMED",
    risk_level: "NORMAL",
    available_margin_days: 118,
  },
  {
    order_id: 9105,
    order_line_id: 9106,
    order_no: "ORD-2026-0904-005",
    customer_po_no: "TL-PO-2026-09-033",
    line_no: 1,
    customer_name: "태림기계",
    site_name: "창원 공장",
    item_code_snapshot: "SPINDLE-LH-500",
    item_name_snapshot: "대형 스핀들 하우징",
    specification_snapshot: "수입 베어링 포함",
    order_quantity: 6,
    unit_code: "EA",
    requested_due_date: "2027-12-20",
    required_start_date: "2026-08-24",
    check_required_date: "2026-07-13",
    schedule_status: "CHECK_REQUIRED",
    risk_level: "OVERDUE",
    available_margin_days: -8,
  },
];
